import { Button } from '@/components/ui/button';
import type { InterpreterRecord, InterpreterRow } from './api';
import { labels } from './interpreterPage.constants';
import { interpreterPageStyles as styles } from './interpreterPage.styles';

interface Props {
  record: InterpreterRecord;
  busy: boolean;
  partial: string;
  onRetry: (row: InterpreterRow) => void;
}
export const InterpreterConversation = ({ record, busy, partial, onRetry }: Props) => {
  const turns = new Map<string, InterpreterRow[]>();
  for (const row of record.utterances) {
    const rows = turns.get(row.turn_id) ?? [];
    rows.push(row);
    turns.set(row.turn_id, rows);
  }
  return (
    <div className={styles.settingsStack} aria-label="Samtal">
      {turns.size === 0 && <p className={styles.conversationEmpty}>Samtalið birtist hér, bæði frumtexti og þýðing.</p>}
      {[...turns.entries()].map(([id, unordered]) => {
        const rows = [...unordered].sort((a, b) => a.n - b.n);
        const language = rows[0].language;
        return (
          <article key={id} className={styles.turn}>
            <p className={styles.turnHeading}>{labels[language]}</p>
            <p dir="auto" className={styles.turnText}>
              {rows.map((row) => row.text).join('\n')}
            </p>
            <div className={styles.translation}>
              <p className={styles.mutedCaption}>
                {
                  labels[
                    rows[0].speaker === 'doctor' ? record.config.patient_language : record.config.clinician_language
                  ]
                }
              </p>
              {rows.map((row) =>
                row.translation_status === 'ready' ? (
                  <p key={row.id} dir="auto" className={styles.turnText}>
                    {row.translation}
                  </p>
                ) : (
                  <div key={row.id} className="space-y-2">
                    <p className={styles.textOnly}>Þýðing ólokin. Upprunalegi textinn er vistaður.</p>
                    <Button variant="outline" disabled={busy} onClick={() => onRetry(row)}>
                      Reyna þýðingu aftur
                    </Button>
                  </div>
                )
              )}
            </div>
          </article>
        );
      })}
      {partial && (
        <p aria-label="Óvistað talrit" dir="auto" className={styles.textOnly}>
          {partial}
        </p>
      )}
    </div>
  );
};
